// Statik Türkiye il/ilçe/mahalle verileri - API olmadan çalışır

export const staticLocationData = {
  cities: [
    { id: 1, name: 'Adana' },
    { id: 2, name: 'Adıyaman' },
    { id: 3, name: 'Afyonkarahisar' },
    { id: 4, name: 'Ağrı' },
    { id: 5, name: 'Amasya' },
    { id: 6, name: 'Ankara' },
    { id: 7, name: 'Antalya' },
    { id: 8, name: 'Artvin' },
    { id: 9, name: 'Aydın' },
    { id: 10, name: 'Balıkesir' },
    { id: 11, name: 'Bilecik' },
    { id: 12, name: 'Bingöl' },
    { id: 13, name: 'Bitlis' },
    { id: 14, name: 'Bolu' },
    { id: 15, name: 'Burdur' },
    { id: 16, name: 'Bursa' },
    { id: 17, name: 'Çanakkale' },
    { id: 18, name: 'Çankırı' },
    { id: 19, name: 'Çorum' },
    { id: 20, name: 'Denizli' },
    { id: 21, name: 'Diyarbakır' },
    { id: 22, name: 'Edirne' },
    { id: 23, name: 'Elazığ' },
    { id: 24, name: 'Erzincan' },
    { id: 25, name: 'Erzurum' },
    { id: 26, name: 'Eskişehir' },
    { id: 27, name: 'Gaziantep' },
    { id: 28, name: 'Giresun' },
    { id: 29, name: 'Gümüşhane' },
    { id: 30, name: 'Hakkari' },
    { id: 31, name: 'Hatay' },
    { id: 32, name: 'Isparta' },
    { id: 33, name: 'Mersin' },
    { id: 34, name: 'İstanbul' },
    { id: 35, name: 'İzmir' },
    { id: 36, name: 'Kars' },
    { id: 37, name: 'Kastamonu' },
    { id: 38, name: 'Kayseri' },
    { id: 39, name: 'Kırklareli' },
    { id: 40, name: 'Kırşehir' },
    { id: 41, name: 'Kocaeli' },
    { id: 42, name: 'Konya' },
    { id: 43, name: 'Kütahya' },
    { id: 44, name: 'Malatya' },
    { id: 45, name: 'Manisa' },
    { id: 46, name: 'Kahramanmaraş' },
    { id: 47, name: 'Mardin' },
    { id: 48, name: 'Muğla' },
    { id: 49, name: 'Muş' },
    { id: 50, name: 'Nevşehir' },
    { id: 51, name: 'Niğde' },
    { id: 52, name: 'Ordu' },
    { id: 53, name: 'Rize' },
    { id: 54, name: 'Sakarya' },
    { id: 55, name: 'Samsun' },
    { id: 56, name: 'Siirt' },
    { id: 57, name: 'Sinop' },
    { id: 58, name: 'Sivas' },
    { id: 59, name: 'Tekirdağ' },
    { id: 60, name: 'Tokat' },
    { id: 61, name: 'Trabzon' },
    { id: 62, name: 'Tunceli' },
    { id: 63, name: 'Şanlıurfa' },
    { id: 64, name: 'Uşak' },
    { id: 65, name: 'Van' },
    { id: 66, name: 'Yozgat' },
    { id: 67, name: 'Zonguldak' },
    { id: 68, name: 'Aksaray' },
    { id: 69, name: 'Bayburt' },
    { id: 70, name: 'Karaman' },
    { id: 71, name: 'Kırıkkale' },
    { id: 72, name: 'Batman' },
    { id: 73, name: 'Şırnak' },
    { id: 74, name: 'Bartın' },
    { id: 75, name: 'Ardahan' },
    { id: 76, name: 'Iğdır' },
    { id: 77, name: 'Yalova' },
    { id: 78, name: 'Karabük' },
    { id: 79, name: 'Kilis' },
    { id: 80, name: 'Osmaniye' },
    { id: 81, name: 'Düzce' }
  ],
  
  districts: {
    34: [ // İstanbul
      { id: 1, name: 'Adalar' },
      { id: 2, name: 'Arnavutköy' },
      { id: 3, name: 'Ataşehir' },
      { id: 4, name: 'Avcılar' },
      { id: 5, name: 'Bağcılar' },
      { id: 6, name: 'Bahçelievler' },
      { id: 7, name: 'Bakırköy' },
      { id: 8, name: 'Başakşehir' },
      { id: 9, name: 'Bayrampaşa' },
      { id: 10, name: 'Beşiktaş' },
      { id: 11, name: 'Beykoz' },
      { id: 12, name: 'Beylikdüzü' },
      { id: 13, name: 'Beyoğlu' },
      { id: 14, name: 'Büyükçekmece' },
      { id: 15, name: 'Çatalca' },
      { id: 16, name: 'Çekmeköy' },
      { id: 17, name: 'Esenler' },
      { id: 18, name: 'Esenyurt' },
      { id: 19, name: 'Eyüpsultan' },
      { id: 20, name: 'Fatih' },
      { id: 21, name: 'Gaziosmanpaşa' },
      { id: 22, name: 'Güngören' },
      { id: 23, name: 'Kadıköy' },
      { id: 24, name: 'Kağıthane' },
      { id: 25, name: 'Kartal' },
      { id: 26, name: 'Küçükçekmece' },
      { id: 27, name: 'Maltepe' },
      { id: 28, name: 'Pendik' },
      { id: 29, name: 'Sancaktepe' },
      { id: 30, name: 'Sarıyer' },
      { id: 31, name: 'Silivri' },
      { id: 32, name: 'Sultanbeyli' },
      { id: 33, name: 'Sultangazi' },
      { id: 34, name: 'Şile' },
      { id: 35, name: 'Şişli' },
      { id: 36, name: 'Tuzla' },
      { id: 37, name: 'Ümraniye' },
      { id: 38, name: 'Üsküdar' },
      { id: 39, name: 'Zeytinburnu' }
    ],
    6: [ // Ankara
      { id: 1, name: 'Akyurt' },
      { id: 2, name: 'Altındağ' },
      { id: 3, name: 'Ayaş' },
      { id: 4, name: 'Bala' },
      { id: 5, name: 'Beypazarı' },
      { id: 6, name: 'Çamlıdere' },
      { id: 7, name: 'Çankaya' },
      { id: 8, name: 'Çubuk' },
      { id: 9, name: 'Elmadağ' },
      { id: 10, name: 'Etimesgut' },
      { id: 11, name: 'Evren' },
      { id: 12, name: 'Gölbaşı' },
      { id: 13, name: 'Güdül' },
      { id: 14, name: 'Haymana' },
      { id: 15, name: 'Kahramankazan' },
      { id: 16, name: 'Kalecik' },
      { id: 17, name: 'Keçiören' },
      { id: 18, name: 'Kızılcahamam' },
      { id: 19, name: 'Mamak' },
      { id: 20, name: 'Nallıhan' },
      { id: 21, name: 'Polatlı' },
      { id: 22, name: 'Pursaklar' },
      { id: 23, name: 'Sincan' },
      { id: 24, name: 'Şereflikoçhisar' },
      { id: 25, name: 'Yenimahalle' }
    ],
    35: [ // İzmir
      { id: 1, name: 'Aliağa' },
      { id: 2, name: 'Balçova' },
      { id: 3, name: 'Bayındır' },
      { id: 4, name: 'Bayraklı' },
      { id: 5, name: 'Bergama' },
      { id: 6, name: 'Bornova' },
      { id: 7, name: 'Buca' },
      { id: 8, name: 'Çeşme' },
      { id: 9, name: 'Çiğli' },
      { id: 10, name: 'Dikili' },
      { id: 11, name: 'Foça' },
      { id: 12, name: 'Gaziemir' },
      { id: 13, name: 'Güzelbahçe' },
      { id: 14, name: 'Karabağlar' },
      { id: 15, name: 'Karaburun' },
      { id: 16, name: 'Karşıyaka' },
      { id: 17, name: 'Kemalpaşa' },
      { id: 18, name: 'Kınık' },
      { id: 19, name: 'Kiraz' },
      { id: 20, name: 'Konak' },
      { id: 21, name: 'Menderes' },
      { id: 22, name: 'Menemen' },
      { id: 23, name: 'Narlıdere' },
      { id: 24, name: 'Ödemiş' },
      { id: 25, name: 'Seferihisar' },
      { id: 26, name: 'Selçuk' },
      { id: 27, name: 'Tire' },
      { id: 28, name: 'Torbalı' },
      { id: 29, name: 'Urla' }
    ]
  },
  
  neighborhoods: {
    23: [ // Kadıköy
      { id: 1, name: 'Acıbadem' },
      { id: 2, name: 'Bostancı' },
      { id: 3, name: 'Caddebostan' },
      { id: 4, name: 'Erenköy' },
      { id: 5, name: 'Fenerbahçe' },
      { id: 6, name: 'Göztepe' },
      { id: 7, name: 'Hasanpaşa' },
      { id: 8, name: 'Kozyatağı' },
      { id: 9, name: 'Moda' },
      { id: 10, name: 'Suadiye' }
    ],
    10: [ // Beşiktaş
      { id: 1, name: 'Arnavutköy' },
      { id: 2, name: 'Bebek' },
      { id: 3, name: 'Etiler' },
      { id: 4, name: 'Levent' },
      { id: 5, name: 'Nişantaşı' },
      { id: 6, name: 'Ortaköy' },
      { id: 7, name: 'Ulus' },
      { id: 8, name: 'Yıldız' }
    ]
  }
};

// API fonksiyonları
export const getCities = async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      // Statik veri için de özel sıralama uygula
      const sortedCities = sortCitiesWithPriority(staticLocationData.cities);
      resolve(sortedCities);
    }, 300);
  });
};

// Şehirleri özel sıralama ile düzenle (statik veri için)
const sortCitiesWithPriority = (cities) => {
  const priorityCities = ['İstanbul', 'Ankara', 'İzmir'];
  const priority = [];
  const others = [];
  
  cities.forEach(city => {
    if (priorityCities.includes(city.name)) {
      priority.push(city);
    } else {
      others.push(city);
    }
  });
  
  // Öncelikli şehirleri belirtilen sıraya göre sırala
  priority.sort((a, b) => {
    const aIndex = priorityCities.indexOf(a.name);
    const bIndex = priorityCities.indexOf(b.name);
    return aIndex - bIndex;
  });
  
  // Diğer şehirleri alfabetik sırala
  others.sort((a, b) => a.name.localeCompare(b.name, 'tr'));
  
  return [...priority, ...others];
};

export const getDistricts = async (cityId) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(staticLocationData.districts[cityId] || []);
    }, 300);
  });
};

export const getNeighborhoods = async (districtId) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(staticLocationData.neighborhoods[districtId] || []);
    }, 300);
  });
};

export const getCityIdByName = (cities, cityName) => {
  const city = cities.find(c => c.name === cityName);
  return city ? city.id : null;
};

export const getDistrictIdByName = (districts, districtName) => {
  const district = districts.find(d => d.name === districtName);
  return district ? district.id : null;
};